/**
 * Created with IntelliJ IDEA.
 * User: ShaharA
 * Date: 15/01/14
 * Time: 3:06 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require){
    "use strict";

    var Marionette = require("marionette");
    var Logger = require('logger');

    var itemTemplate = require('ui/plus-composite-view/templates/defaultPlusComponentItemView.tmpl');

    var DefaultPlusComponentItemView = Marionette.ItemView.extend({
        tagName: 'li',
        className: 'language-item',

        initialize: function(options) {
            this.template = itemTemplate;

            this.vent = options.vent;
            this.logger = Logger.getLogger('PlusCompositeViewWidget');
        },

        /**
         * We have a template helpers in order to use the ability of mustache to have a dynamic key.
         * We want to display the channel and view (from the dictionary) and need its keys from the dictionary.
         * The keys are using the name of the type/channel, so we get those from the model.
         * For example: "LECampaign.engagementDetailsView.type.peeling.text" - We get the text "peeling" from the engagement model according to the saved type in the model.
         * @return {Object}
         */
        customTemplateHelpers: function() {
            var that = this;
            return {
                activeTooltip: function(){
                    return that.model.get("activeTooltip");
                },
                escapeHtml: this.options.escapeHtml
            };
        },

        events: {
            // add custom
        },

        modelEvents: {
            // add custom
        },

        onRender: function() {
            var className = this.model.get("className");
            this.$el.addClass(className);
        }
    });

    return DefaultPlusComponentItemView;
});